import { init as initApm } from '@3vjia/v-apm';
import './style';
import './ui';
import './prototype';
import './filters';
import './directives';
import './charts';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import relativeTime from 'dayjs/plugin/relativeTime';

// 时间国际化
dayjs.locale('zh-cn');

// 计算相对时间插件
dayjs.extend(relativeTime);

// 前端监控
initApm({
  env: process.env.VUE_APP_ENV, // 当前环境
  serviceName: 'designer-h5', // 监控应用名称
});
